var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsLightComputerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:computer-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.66248 56.7642V53.8475H65.3375V56.7642H5.66248ZM13.9604 50.9308C12.6187 50.9308 11.4978 50.4807 10.5975 49.5804C9.69914 48.6821 9.24998 47.5611 9.24998 46.2175V17.7217C9.24998 16.38 9.70011 15.26 10.6004 14.3617C11.5007 13.4633 12.6207 13.0142 13.9604 13.0142H57.0396C58.3812 13.0142 59.5012 13.4633 60.3996 14.3617C61.2998 15.2619 61.75 16.3829 61.75 17.7246V46.2204C61.75 47.5621 61.2998 48.6821 60.3996 49.5804C59.4993 50.4787 58.3793 50.9289 57.0396 50.9308H13.9604ZM13.9604 48.0142H57.0396C57.4868 48.0142 57.898 47.8265 58.2733 47.4512C58.6466 47.0779 58.8333 46.6667 58.8333 46.2175V17.7217C58.8333 17.2744 58.6466 16.8642 58.2733 16.4908C57.898 16.1175 57.4868 15.9308 57.0396 15.9308H13.9604C13.5132 15.9308 13.1019 16.1175 12.7266 16.4908C12.3533 16.8642 12.1666 17.2754 12.1666 17.7246V46.2204C12.1666 46.6676 12.3533 47.0779 12.7266 47.4512C13.1019 47.8265 13.5132 48.0142 13.9604 48.0142Z",
    fill: "#4555BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsLightComputerOutline);
export default __webpack_public_path__ + "static/media/material-symbols-light_computer-outline.8dc818d052bc867ab8dc9a02605512fc.svg";
export { ForwardRef as ReactComponent };